var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"1","y1":"47","x2":"0.999999","y2":"17","stroke":"#F7FFFF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("line",{"x1":"10","y1":"55","x2":"10","y2":"9","stroke":"#F7FFFF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("line",{"x1":"18","y1":"63","x2":"18","y2":"1","stroke":"#F7FFFF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Burger.defaultProps = {"width":"19","height":"64","viewBox":"0 0 19 64","fill":"none"};

module.exports = Burger;

Burger.default = Burger;
